import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=25fbf3ca&"
import script from "./messageCenter.vue?vue&type=script&lang=js&"
export * from "./messageCenter.vue?vue&type=script&lang=js&"
import style0 from "./messageCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports